import { render } from "./project-ar.vue?vue&type=template&id=77292b83&scoped=true"
import script from "./project-ar.vue?vue&type=script&lang=js"
export * from "./project-ar.vue?vue&type=script&lang=js"

import "./project-ar.vue?vue&type=style&index=0&id=77292b83&lang=scss"
import "./project-ar.vue?vue&type=style&index=1&id=77292b83&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77292b83"]])

export default __exports__